export default __webpack_public_path__ + "static/media/IN500.5618122b.png";